function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 420 420"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "80.81%",
  y1: "59.64%",
  x2: "59.87%",
  y2: "8.15%",
  id: "svg3933873156a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EF2131",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FECF2C",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "58.82%",
  y1: "0%",
  x2: "9.24%",
  y2: "94.07%",
  id: "svg3933873156b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FBC52C",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F87130",
  offset: "26.39%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EF52E2",
  offset: "56.08%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#661EEC",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "20.57%",
  y1: "41.02%",
  x2: "40.6%",
  y2: "91.28%",
  id: "svg3933873156c"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#78F6D8",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#77D1F6",
  offset: "26.57%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#70A4F3",
  offset: "55.45%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#661EEC",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "42.44%",
  y1: "100%",
  x2: "91.61%",
  y2: "6.28%",
  id: "svg3933873156d"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#536EED",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#54C3EC",
  offset: "24.67%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#64D769",
  offset: "56.42%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FECF2C",
  offset: "100%"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M0 350.04c84.29 40.32 188.31 20.37 251.16-54.51C325.64 206.77 314.07 74.46 225.32 0L166.3 70.3c69.34 58.18 78.38 161.55 20.19 230.89C140.1 356.47 63.7 374.93 0 350.04",
  fill: "url(#svg3933873156a)",
  transform: "translate(119.33 49.11)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 350.04c84.29 40.32 188.31 20.37 251.16-54.51a211.22 211.22 0 0020.34-28.8c9.92-61.67-11.9-126.86-63.24-169.92a183.65 183.65 0 00-41.94-26.5c69.33 58.18 78.37 161.54 20.18 230.88C140.1 356.47 63.7 374.93 0 350.04",
  fill: "url(#svg3933873156b)",
  transform: "translate(119.33 49.11)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M300.25 20.43C215.97-19.88 111.95.07 49.1 74.95-25.4 163.7-13.82 296 74.94 370.47l59-70.3C64.6 241.99 55.57 138.63 113.77 69.29c46.4-55.3 122.8-73.75 186.5-48.86",
  fill: "url(#svg3933873156c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M300.25 20.43C215.97-19.88 111.95.07 49.1 74.95a211.17 211.17 0 00-20.34 28.8C18.83 165.4 40.66 230.6 92 273.66a183.71 183.71 0 0041.94 26.49C64.6 241.98 55.57 138.62 113.76 69.29c46.4-55.3 122.8-73.75 186.5-48.86",
  fill: "url(#svg3933873156d)"
})));